export default {
  roles: {
    CommonPrefix: "TG_FHD_AMT",
    HomeOfficeReadOnly: "TG_FHD_AMT_RO",
    HomeOfficeReadWrite: "TG_FHD_AMT_RW",
    Agency: "TG_FHD_AMT_AGT_RW",
    LNLAdmin: "TG_AMT_HO_ADMIN",
  },
};
